import { CartCore } from '@theme/cart-core';

window.__QUICK_ADD_BUILD__ = 'QUICKADD-2026-09-13-A';
console.info('[QUICK ADD BUILD]', window.__QUICK_ADD_BUILD__);

/**
 * Thin client. No drawer, badge, totals, HTML, or cart events.
 */
class QuickAddCoreImpl {
  addVariant(variantId, quantity = 1) {
    return CartCore.addVariant(variantId, quantity);
  }
}

export const QuickAddCore = new QuickAddCoreImpl();
window.QuickAddCore = QuickAddCore;
